var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExpandView(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons / Platform"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 660 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.75 4C3.75 3.58579 4.08579 3.25 4.5 3.25H8.5C8.91421 3.25 9.25 3.58579 9.25 4C9.25 4.41421 8.91421 4.75 8.5 4.75H5.25V8C5.25 8.41421 4.91421 8.75 4.5 8.75C4.08579 8.75 3.75 8.41421 3.75 8V4Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 661 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5 3.25C20.9142 3.25 21.25 3.58579 21.25 4L21.25 8C21.25 8.41421 20.9142 8.75 20.5 8.75C20.0858 8.75 19.75 8.41421 19.75 8L19.75 4.75L16.5 4.75C16.0858 4.75 15.75 4.41421 15.75 4C15.75 3.58579 16.0858 3.25 16.5 3.25L20.5 3.25Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 662 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.25 20C21.25 20.4142 20.9142 20.75 20.5 20.75L16.5 20.75C16.0858 20.75 15.75 20.4142 15.75 20C15.75 19.5858 16.0858 19.25 16.5 19.25L19.75 19.25L19.75 16C19.75 15.5858 20.0858 15.25 20.5 15.25C20.9142 15.25 21.25 15.5858 21.25 16L21.25 20Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 663 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 20.75C4.08579 20.75 3.75 20.4142 3.75 20L3.75 16C3.75 15.5858 4.08579 15.25 4.5 15.25C4.91421 15.25 5.25 15.5858 5.25 16L5.25 19.25L8.5 19.25C8.91421 19.25 9.25 19.5858 9.25 20C9.25 20.4142 8.91421 20.75 8.5 20.75L4.5 20.75Z",
    fill: "#111111"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandView);
export default __webpack_public_path__ + "static/media/ExpandView.8a39518990ed03cad04e90128a1faa7a.svg";
export { ForwardRef as ReactComponent };